type LinkItem = {
  name: string
  href: string
}

export const RouteList1: LinkItem[] = [
  {
    name: 'Home',
    href: '/',
  },
  // {
  //   name: 'Avatar',
  //   href: '/avatar/',
  // },
  // {
  //   name: 'History',
  //   href: '/history/',
  // },
  // {
  //   name: 'Shell',
  //   href: '/shell/',
  // },
]

export const RouteList2: LinkItem[] = [
  // {
  //   name: 'Spirit',
  //   href: '/spirit/',
  // },
  // {
  //   name: 'Mint',
  //   href: '/claim/',
  // },
  // {
  //   name: 'Lobby',
  //   href: '/lobby/',
  // },
  // {
  //   name: 'Personal',
  //   href: '/user/',
  // },
]

export const ProjectList: LinkItem[] = [
  // {
  //   name: 'White paper',
  //   href: '',
  // },
  {
    name: 'Wiki',
    href: 'https://docs.phala.world/',
  },
  {
    name: 'Community',
    href: 'https://discord.gg/phalaworld',
  },
  {
    name: 'About Us',
    href: '/team/',
  },
]
